import axios from "axios";
import { Message } from "element-ui";
import { get } from "lodash-es";
import { extractImagePath } from "@/utils/common";
function errorCreate(msg) {
  // const error = new Error(msg)
  Message.error(`${msg}`);
  // throw error
}
function createService() {
  const service = axios.create();
  // 请求拦截
  service.interceptors.request.use(
    (config) => config,
    (error) => {
      // 发送失败
      console.log(error);
      return Promise.reject(error);
    }
  );
  // 响应拦截
  service.interceptors.response.use(
    (response) => {
      // console.log('response', response)
      const { code, data, msg } = response.data;
      if ([1, 200].includes(+code)) {
        // 处理图片相对路径
        if (Array.isArray(data) && data.some((item) => item.image)) {
          return data.map((item) => ({
            ...item,
            image: extractImagePath(item.image),
          }));
        }
        return data;
      }
      switch (code) {
        case 500:
          errorCreate(msg || "服务器内部错误");
          break;
        default:
          errorCreate(msg || "请稍后重试");
          break;
      }
    },
    (error) => {
      const status = get(error, "response.status");
      switch (status) {
        case 400:
          error.message = "请求错误";
          break;
        case 401:
          error.message = "未授权，请登录";
          break;
        case 403:
          error.message = "拒绝访问";
          break;
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`;
          break;
        case 408:
          error.message = "请求超时";
          break;
        case 500:
          error.message = "服务器内部错误";
          break;
        case 501:
          error.message = "服务未实现";
          break;
        case 502:
          error.message = "网关错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        case 504:
          error.message = "网关超时";
          break;
        case 505:
          error.message = "HTTP版本不受支持";
          break;
        default:
          break;
      }
      Message.error(error.message);
      return Promise.reject(error);
    }
  );
  return service;
}
/**
 * @description 创建请求方法
 * @param {Object} service axios 实例
 */
function createRequestFunction(service) {
  return function (config) {
    const configDefault = {
      headers: {
        "Content-Type": get(config, "headers.Content-Type", "application/json"),
        apiVersion: "1.0",
        "x-requested-with": "XMLHttpRequest",
        // token: useUser.token,
        // Authorization: useUser.token,
        timestamp: Date.now(),
      },
      timeout: 10000, // 接口响应超时时间
      // baseURL: process.env.VUE_APP_API,
    };
    return service(Object.assign(configDefault, config));
  };
}
export const service = createService();
export const request = createRequestFunction(service);
